import React from 'react';
import { Badge } from '@one-thd/sui-atomic-components';
export var ODTableStatusBadge = function (_a) {
    var exceptionType = _a.exceptionType;
    var adjustingStatusesToTheDesign = {
        'See Order Details': { text: 'See Order Details', color: 'warning' },
        'Being Processed': { text: 'Processed', color: 'success' },
        Shipped: { text: 'Shipped', color: 'success' },
        'Delivery In-Transit': { text: 'In-Transit', color: 'success' },
        'Delivery Attempted': { text: 'Delivery Attempted', color: 'warning' },
        Delivered: { text: 'Delivered', color: 'success' },
        Backordered: { text: 'Back-Ordered', color: 'warning' },
        Reserved: { text: 'Reserved', color: 'success' },
        'Out for Delivery': { text: 'Out for Delivery', color: 'success' },
        'On Schedule': { text: 'On Schedule', color: 'success' },
        'On its way to Store': { text: 'Shipped to Store', color: 'success' },
        'Ready for Pickup': { text: 'Ready for Pickup', color: 'success' },
        Canceled: { text: 'Canceled', color: 'primary' },
        Returned: { text: 'Returned', color: 'primary' },
        'Return in progress': { text: 'Initiated', color: 'primary' },
        Complete: { text: 'Complete', color: 'success' },
    }[exceptionType];
    return (React.createElement(Badge, { color: (adjustingStatusesToTheDesign === null || adjustingStatusesToTheDesign === void 0 ? void 0 : adjustingStatusesToTheDesign.color) || 'primary', variant: "subtle", size: "small" }, (adjustingStatusesToTheDesign === null || adjustingStatusesToTheDesign === void 0 ? void 0 : adjustingStatusesToTheDesign.text) || exceptionType));
};
